import { connect } from 'react-redux';
import CandidateSlotSchedular from '../../Components/CandidateSlotSchedular/CandidateSlotSchedular';
import { getSettings } from '../../Reducers/SettingsReducer';
import { getEventsById } from '../../Reducers/EventReducer';
import { getApiStatus } from '../../Reducers/ApiStatusReducer';
import * as settingsActions from '../../Actions/SettingsActions';
import * as eventActions from '../../Actions/EventActions';
import { fetchConversation } from '../../Actions/ConnectActions';
import { getConversation } from '../../Reducers/ConnectReducer';

const mapStateToProps = (state) => ({
  settings: getSettings(state),
  eventsById: getEventsById(state),
  conversation: getConversation(state),
  getEventApiStatus: getApiStatus(state, 'getEventById'),
  getConversationApiStatus: getApiStatus(state, 'getConversation'),
});

const mapDispatchToProps = {
  fetchSettings: settingsActions.fetchSettings,
  getEventById: eventActions.getEventById,
  fetchConversation,
};

export default connect(mapStateToProps, mapDispatchToProps)(CandidateSlotSchedular);
